import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { useAuthenticationPreflight } from "Components/Generic/Authentication";
import { importStart } from "Store/Actions";
import { IAction } from "./IAction";

export function useImport(): [boolean, IAction] {
  const dispatch = useDispatch();
  const { preflightAuthentication } = useAuthenticationPreflight();

  const onImport = useCallback(async () => {
    await preflightAuthentication();
    dispatch(importStart());
  }, [dispatch, preflightAuthentication]);

  return [true, onImport];
}
